import { useCallback } from 'react';

import { downloadFile } from '@cast/utils';

import { DataTransferTimeSeries } from '../../../../../cost-report/types/networkCostOverTime';
import { prepareDataFormExport } from '../_utils';

type UseReportDownload = {
  download: () => void;
};

export const useReportDownload = (
  filename: string,
  data: DataTransferTimeSeries
): UseReportDownload => {
  const download = useCallback(() => {
    downloadFile(prepareDataFormExport(data), `${filename}.csv`);
  }, [data, filename]);

  return { download };
};
